import { ExpandMode } from './expand-mode';
export class SelectOption {
public idProperty = 'id';
public textProperty = 'text';
public childProperty: string = null;
public allowMultiple = false;
public closeOnSelection = true;
public items: any[] = [];
public model: any[] | any;
public isOpen = false;
public filter = '';
public filterCaseSensitive = false;
public allowParentSelection = false;
public restructureWhenChildSameName = false;
public maxVisibleItemCount: number;
public expandMode = ExpandMode.None;
/**
 * @return {?}
 */
public isHierarchy(): boolean {
    return this.childProperty && this.childProperty.trim().length > 0;
  }
/**
 * @return {?}
 */
public get filterExpandMode(): ExpandMode {
     if (this.filter !== '') {
        return ExpandMode.All;
     } else {
       return this.expandMode;
     }
  }
/**
 * @return {?}
 */
public displayCheckbox(): boolean {
    return this.allowMultiple && this.isHierarchy();
  }
/**
 * @return {?}
 */
public isValid(): boolean {
    // Check id property value
    return this.idProperty && this.idProperty.trim().length > 0 &&
      // Check text property value
      this.textProperty && this.textProperty.trim().length > 0 &&
      // Check items value
      this.items && Array.isArray(this.items) && this.items.length > 0;
  }
}

function SelectOption_tsickle_Closure_declarations() {
/** @type {?} */
SelectOption.prototype.idProperty;
/** @type {?} */
SelectOption.prototype.textProperty;
/** @type {?} */
SelectOption.prototype.childProperty;
/** @type {?} */
SelectOption.prototype.allowMultiple;
/** @type {?} */
SelectOption.prototype.closeOnSelection;
/** @type {?} */
SelectOption.prototype.items;
/** @type {?} */
SelectOption.prototype.model;
/** @type {?} */
SelectOption.prototype.isOpen;
/** @type {?} */
SelectOption.prototype.filter;
/** @type {?} */
SelectOption.prototype.filterCaseSensitive;
/** @type {?} */
SelectOption.prototype.allowParentSelection;
/** @type {?} */
SelectOption.prototype.restructureWhenChildSameName;
/** @type {?} */
SelectOption.prototype.maxVisibleItemCount;
/** @type {?} */
SelectOption.prototype.expandMode;
}

